import moment from 'moment';
import isEqual from 'lodash/isEqual';
import { EinvoicePage, EinvoiceSummaryDTO } from '../common/types';
import {
  CursorAccess,
  DATE_FORMAT,
  DATE_TIME_FORMAT,
  INVOICE_SUMMARY_INDEX,
  QueryType,
} from './constants';
import { getCursor, readDataWithIndex, writeData } from './db';
import { appConfig } from '../config/app-config';
import { InvoiceSummaryEntity } from '../common/entity';
import { Query } from './types';

export const createOrUpdateInvoiceSummary = async (
  invoices: EinvoiceSummaryDTO[],
  orgId: string
) => {
  try {
    for (const invoice of invoices) {
      const oldData = await readDataWithIndex(
        appConfig.IDB.STORE.INVOICE_SUMMARY,
        [orgId, invoice.invoiceId],
        INVOICE_SUMMARY_INDEX.ORG_ID_INVOICE_ID_INDEX.NAME
      );
      const newData: InvoiceSummaryEntity = {
        ...invoice,
        orgId,
        invoiceDate: moment(invoice.invoiceDate, DATE_FORMAT).toDate(),
      };
      if (oldData && isEqual(oldData, newData)) return;
      if (oldData) newData.id = oldData.id;
      await writeData(appConfig.IDB.STORE.INVOICE_SUMMARY, newData);
    }
  } catch (e) {
    // console.log('Failed to write data to idb', e);
  }
};

export const getInvoicesSummaryFromDb = async (
  orgId: string,
  invoiceStartDate: string,
  invoiceEndDate: string,
  pageNumber: number
): Promise<EinvoicePage | undefined> => {
  try {
    let invoiceSummaries: EinvoiceSummaryDTO[] = [];
    const startDate = moment(invoiceStartDate, DATE_TIME_FORMAT).format(
      DATE_FORMAT
    );
    const endDate = moment(invoiceEndDate, DATE_TIME_FORMAT).format(
      DATE_FORMAT
    );

    const query: Query = {
      lowerBound: [orgId, moment(startDate, DATE_FORMAT).toDate()],
      upperBound: [orgId, moment(endDate, DATE_FORMAT).toDate()],
    };

    let cursor = await getCursor(
      appConfig.IDB.STORE.INVOICE_SUMMARY,
      INVOICE_SUMMARY_INDEX.ORG_ID_DATE_INDEX.NAME,
      query,
      CursorAccess.READ_ONLY,
      QueryType.BOUND
    );

    const offset = pageNumber * appConfig.INVOICE_SUMMARY_PAGE_SIZE;
    if (cursor && offset !== 0) {
      // @ts-ignore
      cursor = await cursor.advance(offset);
    }
    let itemCount = 0;

    while (cursor && itemCount < appConfig.INVOICE_SUMMARY_PAGE_SIZE) {
      const invoiceSummaryEntity = cursor.value as InvoiceSummaryEntity;
      const invoiceSummary: EinvoiceSummaryDTO = {
        ...invoiceSummaryEntity,
        invoiceDate: moment(invoiceSummaryEntity.invoiceDate).format(
          DATE_FORMAT
        ),
      };
      invoiceSummaries = invoiceSummaries.concat(invoiceSummary);
      itemCount += 1;
      cursor = await cursor.continue();
    }

    return {
      pageMetaInfo: {
        currentPage: pageNumber,
      },
      einvoiceSummaryDtos: invoiceSummaries,
    };
  } catch (e) {
    // console.log('Failed to get data from db', e);
  }
};
